var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94583 0.369596C9.45992 -0.116319 8.66154 -0.127691 8.17116 0.36269L3.88328 4.65057L2.14427 2.91155C1.65389 2.42117 0.85551 2.43255 0.369596 2.91846C-0.116318 3.40437 -0.127692 4.20275 0.36269 4.69313L2.97923 7.30967L2.99238 7.32306C2.999 7.32969 3.0057 7.33623 3.01246 7.3427C3.24071 7.56427 3.5338 7.67951 3.82891 7.69134C4.16552 7.70662 4.50924 7.58776 4.76704 7.32996L9.95274 2.14427C10.4431 1.65389 10.4317 0.85551 9.94583 0.369596Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedCheckIcon);
export default __webpack_public_path__ + "static/media/DeprecatedCheckIcon.5fc7132d71df70b176b1c4333ce011fa.svg";
export { ForwardRef as ReactComponent };